import { placed, type Game, type Point } from "../floor/floor-logic";

// PORT OF `showSessionLocation()` / `mapZoomIn()` / `mapZoomOut()` / `clearSelectedSession()`
// IN THE ANGULAR IN PLAY PAGE: WHAT THE MAP AND THE SELECTED-SESSION SIDEBAR DO WHEN A CARD'S
// LOCATION BUTTON IS PRESSED.
export interface MapState {
  // THE SELECTED MACHINE (ANGULAR'S `selected_session_egm`) AND ITS `trigger` FLAG, WHICH MAKES A
  // REPEATED PRESS ON THE SAME MACHINE ALTERNATE BETWEEN ZOOMING OUT AND BACK IN
  machine: (Point & { location: string; trigger: boolean }) | null;
  sidebarOpen: boolean;
  zoomedIn: boolean;
  // WHERE THE MAP IS ZOOMED TO (NULL: THE WHOLE FLOOR) AND WHERE THE PULSE IS
  zoomTo: Point | null;
  pulse: Point | null;
}

export const EMPTY_MAP: MapState = { machine: null, sidebarOpen: false, zoomedIn: false, zoomTo: null, pulse: null };

// RETURNS NULL WHEN THE LOCATION CANNOT BE SHOWN (NO FLOOR GAMES YET, NO GAME AT THAT LOCATION,
// OR ONE WITHOUT COORDINATES) - ANGULAR THEN LEAVES EVERYTHING AS IT WAS
export function locate(state: MapState, games: readonly Game[], location: string | undefined): MapState | null {
  if (!location || games.length === 0) return null;
  const game = games.find((g) => g.location === location);
  if (!game || !placed(game)) return null;
  const at = { x: game.x, y: game.y };
  const m = state.machine;
  if (m && m.location === location && m.x === at.x && m.y === at.y) {
    return m.trigger
      ? { machine: { ...m, trigger: false }, sidebarOpen: true, zoomedIn: true, zoomTo: at, pulse: at }
      : { machine: { ...m, trigger: true }, sidebarOpen: false, zoomedIn: false, zoomTo: null, pulse: state.pulse };
  }
  return { machine: { ...at, location, trigger: false }, sidebarOpen: true, zoomedIn: true, zoomTo: at, pulse: at };
}

// THE SIDEBAR'S "ZOOM IN" / "ZOOM OUT"
export function zoomIn(state: MapState): MapState {
  if (!state.machine) return state;
  return { ...state, zoomedIn: true, zoomTo: { x: state.machine.x, y: state.machine.y } };
}
export function zoomOut(state: MapState): MapState {
  return { ...state, zoomedIn: false, zoomTo: null };
}
